import React from "react"

import { HighlightedText } from "@/components/HighlightText"

import type { TranscriptTurn } from "./parseTranscriptTurns"

interface TranscriptReadViewProps {
  turns: TranscriptTurn[]
  isDeletion?: boolean
  highlightText?: string
  isCurrentMatch?: boolean
}

/** Read-only, conversation-style rendering of a transcript test case input. */
export const TranscriptReadView: React.FC<TranscriptReadViewProps> = ({
  turns,
  isDeletion = false,
  highlightText,
  isCurrentMatch = false,
}) => (
  <div
    className={`flex flex-col gap-2 text-sm ${
      isDeletion ? "opacity-50 line-through" : ""
    }`}
  >
    {turns.map((turn, index) => (
      <div key={index} className="flex flex-col gap-0.5">
        <span className="text-xs font-semibold uppercase tracking-wide text-coval-text-muted">
          {turn.role}
        </span>
        <span className="text-coval-text whitespace-pre-wrap break-words">
          {highlightText ? (
            <HighlightedText
              text={turn.content}
              searchText={highlightText}
              isCurrentMatch={isCurrentMatch}
            />
          ) : (
            turn.content
          )}
        </span>
      </div>
    ))}
  </div>
)
